import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";

const CaseStudies = () => {
  return (
    <>
      <Helmet>
        <title>Case Studies - Mean3 Software Solutions</title>
      </Helmet>
      <div className="hidden sm:block">
        <Section1 />
      </div>
      <div className="bg-gray-100 ">
        <Section2 />
      </div>
    </>
  );
};

export default CaseStudies;
